<template>
  <v-text-field
    autocomplete="off"
    :id="id"
    :ref="id"
    :label="label"
    v-model="autocompleteText"
    :rules="[ valid ]"
    @keydown.tab="tabber($event)"
    @focus="geolocate()"
    @input="input"
  ></v-text-field>
</template>

<script>
import axios from "axios";

axios.defaults.withCredentials = true;

export default {
  name: "LocationInput",
  components: {},
  model: {
    prop: "location",
    event: "locationChanged"
  },
  props: {
    id: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: true
    },
    enableGeolocation: {
      type: Boolean,
      default: true
    },
    location: {}
  },
  data: function() {
    return {
      autocomplete: null,
      autocompleteText:
        this.location.description != null ? this.location.description : ""
    };
  },
  mounted: function() {
    var context = this;

    var afterMounted = this.postMount;

    setTimeout(function() {
      afterMounted();
    }, 2000);
  },
  methods: {
    valid: function() {
      var valid = this.location.id != null && this.autocompleteText != null;

      if (valid) {
        return valid;
      } else {
        return "Please select a location from the dropdown list";
      }
    },
    clear: function(e) {
      this.autocompleteText = "";
    },
    tabber: function(e) {
      this.autocompleteText = document.getElementById(this.id).value;
    },
    postMount: function() {
      const options = {
        // types: [this.types]
        fields: [
          "name",
          "geometry.location",
          "place_id",
          "formatted_address",
          "address_components"
        ]
      };
      if (this.country) {
        options.componentRestrictions = {
          country: this.country
        };
      }
      var input = document.getElementById(this.id);
      input.placeholder = "";
      this.autocomplete = new google.maps.places.Autocomplete(input, options);

      let circle = new google.maps.Circle({
        center: this.$store.state.center,
        radius: 10000
      });

      this.autocomplete.setBounds(circle.getBounds());

      this.autocomplete.addListener("place_changed", () => {
        let place = this.autocomplete.getPlace();
        if (!place.geometry) {
          // User entered the name of a Place that was not suggested and
          // pressed the Enter key, or the Place Details request failed.
          console.log("no results found");
          this.$emit("no-results-found", place);
          return;
        }
        let addressComponents = {
          street_number: "short_name",
          route: "long_name",
          locality: "long_name",
          administrative_area_level_1: "short_name",
          country: "long_name",
          postal_code: "short_name"
        };
        let returnData = {};
        if (place.address_components !== undefined) {
          // Get each component of the address from the place details
          for (let i = 0; i < place.address_components.length; i++) {
            let addressType = place.address_components[i].types[0];
            if (addressComponents[addressType]) {
              let val =
                place.address_components[i][addressComponents[addressType]];
              returnData[addressType] = val;
            }
          }
          returnData["latitude"] = place.geometry.location.lat();
          returnData["longitude"] = place.geometry.location.lng();
          // return returnData object and PlaceResult object

          this.autocompleteText = document.getElementById(this.id).value;
          this.$emit("placechanged", returnData, place);

          var context = this;

          this.sendLocationToServer(
            place.geometry.location.lat(),
            place.geometry.location.lng(),
            this.autocompleteText,
            function(loc) {
              context.$emit("locationChanged", loc);
              context.$nextTick(() => {
                context.$refs[context.id].validate();
              });
            }
          );
        }
      });
    },
    sendLocationToServer(latitude, longitude, description, success) {
      axios({
        url: `${this.$store.state.apiUrl}/location/add`,
        method: "POST",
        params: {
          lat: latitude,
          lon: longitude,
          description: description
        },
        headers: {
          "Content-Type": "application/json"
        }
      })
        .then(function(res) {
          console.log(res.data);
          var loc = {
            id: res.data.id,
            description: res.data.description,
            latLng: {
              latitude: res.data.lat,
              longitude: res.data.lon
            }
          };

          success(loc);
        })
        .catch(err => console.error(err));
    },
    input() {
      this.location.id = null;
    },
    onFocus() {
      this.geolocate();
      this.$emit("focus");
    },
    onBlur() {
      this.$emit("blur");
    },
    // onKeyPress(event) {
    //     console.log(JSON.stringify(this.autocomplete.getFields()));
    //     this.$emit('keypress', event);
    // },
    // Bias the autocomplete object to the user's geographical location,
    // as supplied by the browser's 'navigator.geolocation' object.
    geolocate() {
      if (this.enableGeolocation) {
        if (navigator.geolocation) {
          navigator.geolocation.getCurrentPosition(position => {
            let geolocation = {
              lat: position.coords.latitude,
              lng: position.coords.longitude
            };
            let circle = new google.maps.Circle({
              center: geolocation,
              radius: position.coords.accuracy
            });
            this.autocomplete.setBounds(circle.getBounds());
          });
        }
      }
    },
    remove() {
      this.$emit("removePressed");
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
</style>
